import { LinearProgress } from '@mui/material';
import { CLIENT_PURPLE } from './SupplierScoring.calc';

/** A read-only 0–100 bar in the client purple. */
export const ClientScoreBar = ({ score, label, width }: { score: number; label: string; width?: number }) => (
  <LinearProgress
    variant="determinate"
    value={score}
    aria-label={label}
    sx={{
      width,
      height: 6,
      borderRadius: 3,
      backgroundColor: 'grey.200',
      '& .MuiLinearProgress-bar': { backgroundColor: CLIENT_PURPLE, borderRadius: 3 }
    }}
  />
);
